import getTotalAmountTendered from './getTotalAmountTendered'

export default function getChangeDue(order = {}) {
  if (!order.payments) return 0

  const change = getTotalAmountTendered(order) - order.total
  return Math.max(change.toFixed(2), 0)
}
